import NumbersSlider from "./NumbersSlider";
import ArticlesSlider from  "./ArticlesSlider";

const HomeSliders = {
    Numbers: NumbersSlider,
    Articles: ArticlesSlider
}

export default HomeSliders